module.exports = __webpack_public_path__ + "img/activities-4.2c5735cd.jpg";